import type { DocTypes, MachineFamily } from "@strtmn/sds/types"

export const MachineDocsLinks: {
  [machineFamily in MachineFamily]?: {
    [docType in DocTypes]?:
      | string
      | {
          [srcAddress: string]: string
        }
  }
} = {
  "e-vertifeed": {
    telemetry:
      "https://strautmann-my.sharepoint.com/:x:/p/softwareentwicklung/IQCb2nslGuCHTKqOya6ORm_GATXN0-g3aWd0cHj-JkKf86s?e=fvBWeo",
    // for all dtcs
    dtcs: "https://strautmann-my.sharepoint.com/:x:/p/softwareentwicklung/IQCGNJQLLxlSTIkcx9BAfvHWAU0Rc4qVpnVbdQK-gOh7l9o?e=I2zCLf",
  },
  primus: {
    telemetry:
      "https://strautmann-my.sharepoint.com/:b:/p/softwareentwicklung/IQDk1Cw1aeEkS4ItJoVKVmo-ARTFo7WCfcfpp9R3lN7hCv0?e=Ditp44",
    dtcs: {
      // 0x0000 = "Diesel"
      "0x0000":
        "https://strautmann-my.sharepoint.com/:b:/p/softwareentwicklung/IQABIsOGEAxtQ4bZ3tEi85XxATy7RbH-rqVX3P1aab_0QtQ?e=dgeUnk",
      // 0x0003 = "Fahrantrieb"
      "0x0003":
        "https://strautmann-my.sharepoint.com/:b:/p/softwareentwicklung/IQBNFwduw_VoQa05SW9CmdE8AeXwTK0drSfnowv0VSL-jkE?e=nV8U2G",

      // 0x0008 = "Lenkung"
      "0x0008":
        "https://strautmann-my.sharepoint.com/:b:/p/softwareentwicklung/IQBIiZHg-gECTZoEmmno6LhgAajugcck59huGhWk-0YRk1c?e=wiII4A",
      // 0x0038 = "Lenkung"
      "0x0038":
        "https://strautmann-my.sharepoint.com/:b:/p/softwareentwicklung/IQBIiZHg-gECTZoEmmno6LhgAajugcck59huGhWk-0YRk1c?e=wiII4A",
      // 0x0032 = "BSL Steuerung"
      "0x0032":
        "https://strautmann-my.sharepoint.com/:x:/p/softwareentwicklung/IQB0vzDB44FnQ4gd3smmNCV-AZivVAWXZIiG2SevqyWt25E?e=yxWr8p",
    },
  },
}
